<template>
  <div class="reports-index">
    <el-form class="search-filter">
      <div class="filter-worker">
        <date-picker
          :editable="false"
          ref="datePicker"
          placeholder="Фильтр по дате"
          range
          v-model="filter.datetimeRange"
          @change="changeFiled"
        ></date-picker>
      </div>
      <div class="filter-worker">
        <filter-select
          v-if="userRole === 'admin'"
          v-model="filter.users"
          label="Выберите пользователя"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.users"
        />
        <strong style="margin-top: 10px;display: block;" v-if="userRole !== null && userRole !== 'admin'">{{filter.users.label}}</strong>
      </div>
      <div class="filter-worker">
        <filter-select
          v-model="filter.object"
          label="Выберите обьект"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.objects"
        />

        <!--        <el-select-->
        <!--          v-model="filter.object"-->
        <!--          @change="changeFiled"-->
        <!--          placeholder="Выберите обьект"-->
        <!--        >-->
        <!--          <el-option-->
        <!--            v-for="item in filterCollection.objects"-->
        <!--            :key="item.id"-->
        <!--            :label="item.name"-->
        <!--            :value="item.id"-->
        <!--          >-->
        <!--          </el-option>-->
        <!--        </el-select>-->
      </div>
    </el-form>
    <h1 v-if="empty">По выбраному фильтру ничего не найдено</h1>
    <dl class="info-block" v-if="!empty">
      <div class="analytics-views" v-loading="loader">
        <div v-for="row in analytics" class="analytic-row">
          <strong class="title">{{ row.name }}, {{ row.unit }}<small v-if="row.error">{{ row.error }}</small></strong>

          <div class="analytics-info">
            <div>
              <span class="name">План/Факт</span>
              <strong>{{ (row.plan).toFixed(2) }}/{{ (row.value).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">+/-</span>
              <strong>{{ (row.value - row.plan).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">%</span>
              <strong v-if="row.plan !== 0">{{ (row.value * 100 / row.plan).toFixed(1) }}</strong>
            </div>
          </div>
        </div>
      </div>

    </dl>
  </div>


</template>

<script>
import firebase from 'firebase'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import getItemsForUser from '../../../utils/getItemsForUser'
import FilterSelect from '../../../components/FilterSelect';
import {formatEndDate, formatStartDate} from "../../../utils/date";


export default {
  name: 'List',
  components: {DatePicker, FilterSelect},
  data () {
    return {
      loader: false,
      analytics: [],
      empty: false,
      shortcuts: [
        {
          text: 'День',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'Неделя',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 7 * 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'Месяц',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 31 * 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'За все время',
          onClick () {
            return []
          },
        },
      ],
      filter: {
        users: null,
        object: null,
        typeJob: null,
        datetimeRange: [],
      },
      filterCollection: {
        users: [],
        objects: [],
      },
      projectWorksType: {},
      workTypeMap: {},
      prepareJobs: {},
      mapJobs: {},
      userRole: null
    }
  },
  mounted () {
    if (this.$store.state.project.disableDate) {
      this.filter.datetimeRange = [
        new Date('2021-08-24'),
        new Date('2021-09-02')
      ]
    }
    const defaultQuery = firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('reports')
      .where('type', '==', 'JOB')
    this.loader = true
    const promiseUser = this.fetchUsers(defaultQuery)
    const promiseObject = this.fetchObjects()
    Promise.all([promiseUser, promiseObject])
      .then(() => this.changeFiled())
      .then(() => this.loader = false)
  },
  methods: {
    workTypeForProject () {
      if (Object.keys(this.projectWorksType).length > 0) {
        return Promise.resolve(this.projectWorksType)
      }
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .where('analytics', '==', true)
        .get().then(response => {
          const result = []
          response.forEach((sub) => {
            const tmp = {
              _id: sub.id,
              ...sub.data()
            }
            result.push(tmp)
          })
          this.projectWorksType = result.reduce((acum, item) => {
            this.workTypeMap[item._id] = item.name
            acum[`${item._id}_${item.unit.label}`] = item
            return acum
          }, {})
          return this.projectWorksType
        })
    },
    fetchPrepareJobs (workType) {
      if (Object.keys(this.prepareJobs).length > 0) {
        return Promise.resolve(this.prepareJobs)
      }
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs').get().then(response => {
          const result = []
          response.forEach(sub => {
            result.push({...sub.data(), ...{_id: sub.id}})
          })
          this.mapJobs = result.reduce((acum, item) => {
            acum[item._id] = item
            return acum
          }, {})
          this.prepareJobs = result.filter(i => !!workType[`${i.work_type}_${i.unit}`]).reduce((acum, item) => {
            if (!acum[`${item.work_type}_${item.unit}`]) {
              acum[`${item.work_type}_${item.unit}`] = []
            }
            acum[`${item.work_type}_${item.unit}`].push({...item, ...{index: workType[`${item.work_type}_${item.unit}`].index}})
            return acum
          }, {})
          return this.prepareJobs
        })
    },
    fetchObjects () {
      const objectsArray = []

      const loadObjectByParentId = (id, result = []) => {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('objects')
          .doc(id)
          .get().then(r => {
            const data = r.data()
            if (!data) {
              return result
            }
            const {parentId, name, index} = data
            result.push({id: id, name: name, index: index})
            if (!parentId) {
              return result
            }
            return loadObjectByParentId(parentId, result)

          })
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('objects')
        .get().then((response) => {
          response.forEach((sub) => {
            const data = {...sub.data(), ...{_id: sub.id,}}
            objectsArray.push(data)
          })
          return Promise.all(objectsArray.filter(item => !!item).map(item => loadObjectByParentId(item._id, [])))
        }).then(objectsArrayFromDirectory => {
          const objectsArray = objectsArrayFromDirectory.filter(i => i.length > 0).map((item) => {
            const reverseItem = item.reverse()
            return {
              id: reverseItem[reverseItem.length - 1].id,
              name: reverseItem.map(item => item.name).join(' > '),
              index: reverseItem[reverseItem.length - 1].index
            }
          })
          const acumObject = {
            [null]: {
              value: null,
              label: 'Все обьекты',
            },
          }

          const filterObject = Object.values(
            objectsArray.filter(item => !!item)
              .sort((a, b) => {
                const fa = a.index
                const fb = b.index

                if (fa < fb) {
                  return -1
                }
                if (fa > fb) {
                  return 1
                }
                return 0
              })
              .reduce((acum, item) => (acum[item.id] = {value: item.id, label: item.name}, acum), acumObject),
          )

          return getItemsForUser(
            firebase.auth().currentUser.uid,
            this.$store.state.project.id
          ).then((accessData) => {
            return {accessData, filterObject}
          })

        }).then(({accessData, filterObject}) => {
          if (accessData.user.role === 'admin' || accessData.company.usePermission !== true) {
            this.filterCollection.objects = filterObject;
            return;
          }
          this.filterCollection.objects = filterObject.filter((item) => {
            return item.value === null || accessData.saveObject[item.value];
          })
        })
    },
    loadObject (object, result = []) {
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('objects')
        .where('parentId', '==', object)
        .get().then(r => {
          const childId = []
          r.forEach(t => {
            childId.push(t.id)
          })
          result.push(object)
          result.push(...childId)

          if (childId.length === 0) {
            return result
          }
          return Promise.all(childId.map(id => this.loadObject(id, result)))
        })
    },
    fetchUsers (defaultQuery) {
      const loadUserFromDirectory = (id) => {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .doc(id)
          .get().then(r => r.data())
      }
      const usersArray = []
      return defaultQuery
        .get().then((response) => {
          response.forEach((sub) => {

            const data = sub.data()
            usersArray.push(data.user)
          })
          return Promise.all(
            usersArray.map(i => loadUserFromDirectory(i.user_profile_id).then((r) => r || i))
          )

        }).then((usersArray) => {
          const users = Object.values(usersArray.reduce((acum, item) => (acum[item.uid] = item, acum), {}))
          const resultList = users.reduce((acum, i) => {
            const name = i.company || i.name || i.email
            acum[name] = acum[name] || []
            acum[name].push(i.uid)
            return acum
          }, {})
          const resultUser = Object.entries(resultList).map(([key, val]) => ({
            uid: val.join(','),
            company: key,
          }))
          resultUser.unshift({
            uid: null,
            company: 'Все исполнители',
          })

          this.filterCollection.users = resultUser.map((item) => ({
            value: item.uid,
            label: item.company || item.email,
          }))
        })
        .then(() => {
          return getItemsForUser(
            firebase.auth().currentUser.uid,
            this.$store.state.project.id
          )
        }).then(({user}) => {
          const {company, role} = user;
          this.userRole = role;
          if (role !== 'admin') {
            this.filterCollection.users = this.filterCollection.users.filter(value => value.label === company)
            this.filter.users = this.filterCollection.users[0]
            this.filter.users = this.filter.users || {label: company}
          }
        })
    },
    changeFiled () {
      let query = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .where('type', '==', 'JOB')

      if (this.filter.datetimeRange[0] && this.filter.datetimeRange[1]) {
        const endDate = this.filter.datetimeRange[1]
        const startDate = this.filter.datetimeRange[0]

        query = query.where('dateunix', '>=', formatStartDate(startDate))
        query = query.where('dateunix', '<=', formatEndDate(endDate))
      }

      if (this.filter.users && this.filter.users.value) {
        query = query.where('user.uid', 'in', this.filter.users.value.split(','))
      }

      return this.workTypeForProject().then((workType) => {
        return this.fetchPrepareJobs(workType)
      }).then((jobsPlanObject) => {

        query.get().then((response) => {
          const result = []
          response.forEach((sub) => {
            result.push(...sub.data().jobs)
          })
          return result

        })
          .then((response) => {
            if (this.filter.object && this.filter.object.value) {
              return this.loadObject(this.filter.object.value).then(r => {
                const flatArray = r.flat(2)
                const filter = flatArray.reduce((acum, item) => {
                  acum[item] = true
                  return acum
                }, {})
                return [response, filter]
              })
            }
            return [response, {}]

          })
          .then(([response, filter]) => {
            return getItemsForUser(
              firebase.auth().currentUser.uid,
              this.$store.state.project.id
            ).then((accessData) => [response, filter, accessData])
          })
          .then(([response, filter, accessData]) => {
            if (Object.keys(filter).length > 0) {
              jobsPlanObject = Object.entries(jobsPlanObject).reduce((acum, [key, val]) => {
                const withObject = val.filter(i => i.objects.find(i => filter[i]))
                if (withObject.length > 0) {
                  acum[key] = withObject
                }
                return acum
              }, {})
            }
            const objectMap = this.filterCollection.objects.filter(i => i.value).reduce((acum, item) => {
              acum[item.value] = true
              return acum
            }, {})
            const jobFromReport = response
              .map(item => {
                if (this.mapJobs[item.job.id]) {
                  item.job.work_type = this.mapJobs[item.job.id].work_type
                  item.job.work_type_name = this.mapJobs[item.job.id].work_type_name
                  item.job.unit = this.mapJobs[item.job.id].unit
                }
                return item
              })
              .filter(val => {
                return (val.job.objects || []).filter(i => i === 'all' || objectMap[i]).length > 0
              })
              .filter(i => {
                if (Object.keys(filter).length === 0) {
                  return true
                }
                return i.job.objects.find(i => filter[i])
              })
              .filter(item => !!this.prepareJobs[`${item.job.work_type}_${item.job.unit}`])
              .reduce((acum, item) => {
                if (acum[`${item.job.work_type}_${item.job.unit}`]) {
                  acum[`${item.job.work_type}_${item.job.unit}`].value += isNaN(parseFloat(item.value)) ? 0 : parseFloat(item.value)
                } else {
                  acum[`${item.job.work_type}_${item.job.unit}`] = {
                    value: isNaN(parseFloat(item.value)) ? 0 : parseFloat(item.value),
                    name: item.job.work_type_name,
                    id: item.work_type,
                    unit: item.job.unit
                  }
                }

                return acum
              }, {})


            const jobsPlanObjectCount = Object.entries(jobsPlanObject)
              .reduce((acum, [key, val]) => {
                return (val || [])
                  .filter(val => {
                    return val.objects.filter(i => i==='all' || objectMap[i]).length > 0
                  })
                  .reduce((a, i) => {
                    if (a[key]) {
                      a[key].plan += isNaN(parseFloat(i.plan)) ? 0 : parseFloat(i.plan)
                    } else {
                      a[key] = {
                        name: this.workTypeMap[i.work_type],
                        unit: i.unit,
                        plan: isNaN(parseFloat(i.plan)) ? 0 : parseFloat(i.plan),
                        index: i.index
                      }
                    }
                    return a
                  }, acum)
              }, {})
            this.analytics = Object.entries(jobsPlanObjectCount)
              .map(([key, val]) => {

                return {
                  name: val.name,
                  plan: val.plan ? val.plan : 0,
                  value: (jobFromReport[key] && jobFromReport[key].value) ? jobFromReport[key].value : 0,
                  unit: val.unit,
                  index: val.index,
                  error: (!val.plan && val.plan !== 0) ? 'Нет плана' : false
                }
              }).sort((a, b) => a.index > b.index && 1 || -1)
            this.empty = this.analytics.length === 0
          })
      })

    },
  },
}
</script>

<style scoped lang="scss">

.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 764px) {
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: 100%;

    .el-select {
      width: 100%;
    }
  }
}

.filter-worker {
  min-width: 200px;
  margin-top: 10px;
  margin-right: 5px;
}

@media screen and (min-width: 764px) {
  .filter-worker {
    height: 48px;
  }
}

.chart-div {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  div {
    width: 500px !important;
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
  }
}

.info-block {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

dl {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

dt {
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  text-align: right;
  box-sizing: border-box;
  padding-right: 10px;
  font-weight: bold;
  margin: 0px;
}

dd {
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10px;
  margin: 0px;
}

> > > .mx-datepicker-range {
  width: 100%;

  .mx-input {
    border: 1px solid #DCDFE6;
    height: 40px;
  }
}

> > > .el-table__body {
  .cell {
    font-weight: 600;
  }
}

.analytics-views {
  width: calc(100% - 40px);
  margin: 10px auto 22px auto;
  padding-top: 0px;
}

.analytic-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  margin-top: 15px;
  flex-direction: column;

  .title {
    margin-bottom: 4px;
  }

  .name {
    margin-right: 8px;
  }
}

.analytics-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 4px;
  padding-top: 0;
  flex: 1;

  div {
    text-align: left;
  }

  .name {
    color: #3a8ee6;
    font-weight: 600;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 764px) {
  .analytics-info {
    flex-direction: column;

    div {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/List.vue